import { createFileRoute, useRouter } from "@tanstack/solid-router"
import Trash from "lucide-solid/icons/trash"
import { Button } from "~/components/ui/button"
import { Card } from "~/components/ui/card"
import { authClient } from "~/lib/auth/client"

export const Route = createFileRoute("/_auth/login")({
  component: RouteComponent
})

function RouteComponent() {
  const search = Route.useSearch()
  const router = useRouter()

  return (
    <div class="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 p-4 dark:from-gray-900 dark:via-blue-900 dark:to-indigo-900">
      <Card class="w-full max-w-md border border-white/30 bg-white/20 p-8 shadow-2xl backdrop-blur-lg dark:border-white/10 dark:bg-black/20">
        <div class="space-y-6 text-center">
          <div class="space-y-2">
            <h1 class="font-semibold text-2xl text-gray-900 dark:text-white">Welcome</h1>
            <p class="text-gray-600 dark:text-gray-300">Sign in to continue</p>
          </div>
          <Button
            class="flex w-full items-center justify-center gap-3 rounded-lg bg-[#5865F2] px-4 py-3 font-medium text-white transition-colors duration-200 hover:bg-[#4752C4]"
            size="lg"
            onClick={() =>
              authClient.signIn.social({
                provider: "discord",
                callbackURL: search().redirect,
                fetchOptions: {
                  onSuccess: async () => {
                    await router.invalidate()
                  }
                }
              })
            }
          >
            <Trash size={20} />
            Sign In with Discord
          </Button>
        </div>
      </Card>
    </div>
  )
}
